// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__RoyD4","page_center":"Loader_page_center__UmZhM","center_disabled":"Loader_center_disabled__+M88p","disableMargin":"Loader_disableMargin__CAaRV"};